// extracted by mini-css-extract-plugin
export default {"imageBack":"styles_imageBack__xLrcR"};